import React from 'react'
import { Text } from 'components'

export default ({ ...props }) => <Text margin="32px 0 0 0">Clients</Text>
